// extracted by mini-css-extract-plugin
module.exports =  {"title-parts-wrapper":"_32bbee5fda--title-parts-wrapper--mi8Rf"};